<template>
    <div class="jd-goods-detail">
      <div class="jd-container">
        <!-- 商品主图区域 -->
        <div class="jd-gallery">
          <div 
            class="main-image-wrapper"
            @mousemove="handleMouseMove"
            @mouseenter="showZoom = true"
            @mouseleave="showZoom = false"
          >
            <img 
              :src="currentImage" 
              class="main-image"
              ref="mainImage"
              @error="handleImageError"
            >
            <div 
              class="zoom-lens" 
              v-show="showZoom"
              :style="lensStyle"
            ></div>
          </div>
          
          <div 
            class="zoom-preview" 
            v-show="showZoom"
            :style="previewStyle"
          ></div>
  
          <div class="thumbnail-list">
            <div
              v-for="(img, index) in goodsDetail.images"
              :key="index"
              class="thumbnail-item"
              :class="{active: currentImage === img}"
              @click="currentImage = img"
            >
              <img 
                :src="img" 
                alt="商品图片"
                @error="handleThumbnailError"
              >
            </div>
          </div>
        </div>
  
        <!-- 商品信息区域 -->
        <div class="goods-info">
          <h1 class="goods-title">{{ goodsDetail.title }}</h1>
          
          <!-- 价格区块 -->
          <div class="price-block">
            <div class="price-label">京东价</div>
            <div class="price-content">
              <span class="symbol">¥</span>
              <span class="amount">{{ goodsDetail.price.toFixed(2) }}</span>
            </div>
          </div>
  
          <!-- 商品服务信息 -->
          <div class="service-info">
            <div class="service-item">
              <span class="label">发布时间</span>
              <span class="value">{{ goodsDetail.publishTime }}</span>
            </div>
            <div class="service-item">
              <span class="label">累计浏览</span>
              <span class="value">{{ goodsDetail.views.toLocaleString() }}次</span>
            </div>
          </div>
  
          <!-- 商家信息 -->
          <div class="seller-info">
            <el-avatar 
              :size="50" 
              :src="goodsDetail.publisher.avatar"
              class="seller-avatar"
            >
              <img src="https://picsum.photos/50/50?random=4"/>
            </el-avatar>
            <div class="seller-detail">
              <div class="name">{{ goodsDetail.publisher.name }}</div>
              <div class="tags">
                <el-tag type="warning" size="mini">个人卖家</el-tag>
              </div>
            </div>
          </div>
  
          <!-- 操作按钮 -->
          <div class="action-buttons">
            <el-button
              v-if="!isCar"
              type="primary"
              size="large"
              class="cart-btn"
              @click="addToCart"
            >
              <i class="el-icon-shopping-cart-full"></i>
              加入购物车
            </el-button>
            <el-button
              v-if="isCar"
              type="warning"
              size="large"
              class=""
              @click="goCar()"
            >
              <i class="el-icon-shopping-cart-full"></i>
              去购物车结算
            </el-button>
            <el-button
              size="large"
              class="cancel-btn"
              @click="cancel"
            >
              取消
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        token: sessionStorage.getItem('token'),
        isCar:false,//是否加入购物车
        currentImage: '',
        showZoom: false,
        lensPosition: { x: 0, y: 0 },
        previewPosition: { left: 0, top: 0 },
        goodsDetail: {
          title: '皇家狗粮',
          price: 199,
          publishTime: '2023-08-30 10:00:00',
          views: 15234,
          images: [
            'https://picsum.photos/800/800?random=1',
            'https://picsum.photos/800/800?random=2',
            'https://picsum.photos/800/800?random=3'
          ],
          publisher: {
            name: '个人卖家',
            avatar: 'https://picsum.photos/50/50?random=4'
          }
        }
      }
    },
    computed: {
      lensStyle() {
        return {
          left: `${this.lensPosition.x - 75}px`,
          top: `${this.lensPosition.y - 75}px`,
          opacity: this.showZoom ? 1 : 0
        }
      },
      previewStyle() {
        return {
          left: `${this.previewPosition.left}px`,
          top: `${this.previewPosition.top}px`,
          backgroundImage: `url(${this.currentImage})`,
          backgroundPosition: `${-this.lensPosition.x * 2 + 150}px ${-this.lensPosition.y * 2 + 150}px`,
          backgroundSize: `${this.$refs.mainImage?.naturalWidth * 2}px ${this.$refs.mainImage?.naturalHeight * 2}px`
        }
      }
    },
    mounted() {
      this.currentImage = this.goodsDetail.images[0]
      window.addEventListener('scroll', this.updatePreviewPosition)
      window.addEventListener('resize', this.updatePreviewPosition)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.updatePreviewPosition)
      window.removeEventListener('resize', this.updatePreviewPosition)
    },
    methods: {
      handleImageError(e) {
        e.target.src = 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png'
      },
      handleThumbnailError(e) {
        e.target.src = 'https://via.placeholder.com/80x80.png?text=Thumbnail'
      },
      handleMouseMove(e) {
        if (!this.$refs.mainImage) return
        
        const rect = this.$refs.mainImage.getBoundingClientRect()
        const x = e.clientX - rect.left
        const y = e.clientY - rect.top
        
        const maxX = rect.width - 150
        const maxY = rect.height - 150
        
        this.lensPosition = {
          x: Math.max(0, Math.min(x, maxX)),
          y: Math.max(0, Math.min(y, maxY))
        }
        
        this.updatePreviewPosition()
      },
      updatePreviewPosition() {
        const galleryRect = document.querySelector('.jd-gallery').getBoundingClientRect()
        this.previewPosition = {
          left: galleryRect.right + 20,
          top: galleryRect.top + window.scrollY
        }
      },
      addToCart() {
        if(this.token != null){
          this.$confirm('确定要将此商品加入购物车吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.isCar =  !this.isCar
          this.$message.success('商品已成功加入购物车')
        }).catch(() => {})
        }else{
          this.$message.error('未登录，请先登录')
        }
       
      },
      cancel() {
        this.$router.go(-1)
      },
      //
      goCar(){
        this.$router.push('/carDialog')
      }
    }
  }
  </script>
  
  <style scoped>
  .jd-goods-detail {
    background: #fff;
    padding: 20px 0;
    min-height: 100vh;
  }
  
  .jd-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    padding: 0 20px;
  }
  
  /* 图片展示区域 */
  .jd-gallery {
    flex: 0 0 600px;
    margin-right: 40px;
    position: relative;
  }
  
  .main-image-wrapper {
    position: relative;
    border: 1px solid #e0e0e0;
    margin-bottom: 20px;
    cursor: crosshair;
    overflow: hidden;
    background: #f8f8f8;
    border-radius: 4px;
  }
  
  .main-image {
    width: 100%;
    height: auto;
    min-height: 500px;
    object-fit: cover;
    display: block;
  }
  
  .zoom-lens {
    position: absolute;
    width: 150px;
    height: 150px;
    border: 2px solid #e4393c;
    background: rgba(255,255,255,.3);
    pointer-events: none;
    transition: opacity 0.2s;
  }
  
  .zoom-preview {
    position: absolute;
    width: 400px;
    height: 400px;
    border: 1px solid #e0e0e0;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    z-index: 2000;
    pointer-events: none;
  }
  
  .thumbnail-list {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    padding-bottom: 10px;
  }
  
  .thumbnail-item {
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    border: 2px solid transparent;
    cursor: pointer;
    background: #f8f8f8;
    border-radius: 4px;
    overflow: hidden;
    transition: border-color 0.2s;
  }
  
  .thumbnail-item:hover,
  .thumbnail-item.active {
    border-color: #e4393c;
  }
  
  .thumbnail-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  /* 商品信息区域 */
  .goods-info {
    flex: 1;
    min-width: 400px;
    padding-left: 40px;
  }
  
  .goods-title {
    font-size: 24px;
    color: #333;
    margin: 0 0 20px;
    font-weight: 700;
    line-height: 1.4;
  }
  
  .price-block {
    display: flex;
    align-items: center;
    padding: 15px;
    background: #fff4f4;
    margin-bottom: 20px;
    border-radius: 4px;
  }
  
  .price-label {
    color: #999;
    margin-right: 15px;
    font-size: 14px;
  }
  
  .price-content {
    color: #409EFF;
    display: flex;
    align-items: baseline;
  }
  
  .symbol {
    font-size: 24px;
    margin-right: 2px;
  }
  
  .amount {
    font-size: 36px;
    font-weight: 700;
  }
  
  .service-info {
    padding: 15px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
  }
  
  .service-item {
    display: flex;
    align-items: center;
    margin: 10px 0;
    color: #666;
    font-size: 14px;
  }
  
  .service-item .label {
    width: 80px;
    color: #999;
  }
  
  .seller-info {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #eee;
  }
  
  .seller-avatar {
    margin-right: 15px;
    border: 1px solid #eee;
  }
  
  .seller-detail .name {
    font-size: 16px;
    color: #333;
    margin-bottom: 8px;
    font-weight: 500;
  }
  
  .tags .el-tag {
    margin-right: 8px;
  }
  
  .action-buttons {
    margin-top: 30px;
    display: flex;
    gap: 15px;
  }
  
  .cart-btn {
    background: #409EFF;
    border-color:#409EFF;
    color: #fff;
    padding: 15px 30px;
    font-size: 18px;
    border-radius: 4px;
    transition: all 0.2s;
  }
  
  .cart-btn:hover {
    background: #409EFF;
    border-color:#409EFF;
  }
  
  .cancel-btn {
    padding: 15px 30px;
    border-color: #909399;
    color: #666;
    transition: all 0.2s;
  }
  
  .cancel-btn:hover {
    border-color: #ccc;
    color: #333;
  }
  
  @media (max-width: 1200px) {
    .zoom-preview {
      display: none;
    }
  }
  
  @media (max-width: 992px) {
    .jd-container {
      flex-direction: column;
    }
    
    .jd-gallery {
      flex: none;
      max-width: 100%;
      margin-right: 0;
      margin-bottom: 30px;
    }
    
    .goods-info {
      padding-left: 0;
    }
  }
  
  @media (max-width: 768px) {
    .main-image {
      min-height: 300px;
    }
    
    .price-content .amount {
      font-size: 28px;
    }
    
    .action-buttons {
      flex-direction: column;
    }
    
    .cart-btn,
    .cancel-btn {
      width: 100%;
      justify-content: center;
    }
  }
  </style>